import React from "react";
import Container from "./containerUserFeedBack";
import RatingComponent from "./starRatingComponent";
import { feedbackImage } from "../Images";
import "./feedback.css";

class FeedBackForm extends React.Component {
  state = { comment: "", require: false };
  userFeedBack = () => {
    const { data } = this.props;
    if (data.ratings <= 2) {
      data["view"] = "regretScreen";
    } else {
      data["view"] = "thankYouFeedBack";
    }
    return data;
  };
  handleChange = event => {
    this.setState({ comment: event.target.value });
    const { data } = this.props;
    data["comment"] = event.target.value;
    console.log("data", data);
  };

  render() {
    const { onSubmit, data, starField, commentField, isMobile, logo, subsidiaryName, resources } = this.props;
    return (
      <Container
        headtext="SHARE YOUR FEEDBACK"
        data={{ ...data,subsidiaryName, resources }}
        isMobile={isMobile}
        logo={logo}
        subtext="This Feedback is for the entire project, thus the rating for every resource will be same"
      >
        <div className="box">
          <h3 className={isMobile ? "feedbackTextSM" : "feedbackTextMD"}>How happy are you with our services?</h3>

          <RatingComponent data={data} isMobile={isMobile} />

          {!starField ? (
            <div
              style={{
                marginTop: 10
              }}
            >
              <span style={{ color: "red" }}>*rating is mandatory</span>
            </div>
          ) : null}

          {!isMobile ? (
            <div className="textBox">
              <div className="textMD">
                <p style={{ fontFamily: "Nunito-SemiBold", fontSize: "14.5px", color: "#444444", textAlign : "center" }}>
                  Extremly Dissatisfied
                </p>
              </div>
              <div className="textMD">
                <p style={{ fontFamily: "Nunito-SemiBold", fontSize: "14.5px", color: "#444444" , textAlign : "center"}}>
                  Somewhat Dissatisfied
                </p>
              </div>
              <div className="textMD">
                <p style={{ fontFamily: "Nunito-SemiBold", fontSize: "14.5px", color: "#444444" ,textAlign : "center"}}>
                  Niether Satisfied nor Dissatisfied
                </p>
              </div>
              <div className="textMD">
                <p style={{ fontFamily: "Nunito-SemiBold", fontSize: "14.5px", color: "#444444" ,textAlign : "center" }}>
                  Somewhat Satisfied
                </p>
              </div>
              <div className="textMD">
                <p style={{ fontFamily: "Nunito-SemiBold", fontSize: "14.5px", color: "#444444" ,textAlign : "center"}}>
                  Extremely Satisfied
                </p>
              </div>
            </div>
          ) : null}
            <h3 className={isMobile ? "commentTextSM" : "commentTextMD"}>Comments / Your Suggestions</h3>
          <div className="commentBox">
            <textarea
              className={isMobile ? "innerCommentBoxSM" : "innerCommentBoxMD"}
              placeholder="Type Here"
              value={this.state.comment}
              onChange={this.handleChange}
            />
            {!commentField ? <span style={{ color: "red" }}>*comment is mandatory</span> : null}
          </div>
        </div>
        {subsidiaryName === "Unthinkable Solutions LLP" || subsidiaryName === "Hisar-Unthinkable Solutions LLP" ? 
        <div className="submitBox">
        <div className={isMobile ? "submitButtonSM unthinkable" : "submitButtonMD unthinkable"}>
                  <div
                    className={isMobile ? "submitTextSM" : "submitTextMD"}
                    onClick={() =>  onSubmit(this.userFeedBack())}
                  >
                    Submit Project Feedback
                  </div>
                </div>
        </div> :
        <div className="submitBox">
        <div className={isMobile ? "submitButtonSM daffodil" : "submitButtonMD daffodil"}>
                  <div
                    className={isMobile ? "submitTextSM" : "submitTextMD"}
                    onClick={() =>  onSubmit(this.userFeedBack())}
                  >
                    Submit Project Feedback
                  </div>
                </div>
        </div>}
      </Container>
    );
  }
}

export default FeedBackForm;
